import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ModoDiligenciemientoComponent } from '../modo-diligenciemiento/modo-diligenciemiento.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-calculo-extemporaneidad',
  templateUrl: './calculo-extemporaneidad.component.html',
  styleUrls: ['./calculo-extemporaneidad.component.css']
})
export class CalculoExtemporaneidadComponent implements OnInit {

  form: FormGroup;
  submitted = false;
  gradualidadLista : {id: number, value: string}[] = [{id: 1, value: 'Primera declaración extemporánea. '},  
                                                      {id: 2, value: 'Dos años anteriores'}, 
                                                      {id: 3, value: 'Año anterior'},
                                                      {id: 4, value: 'No aplica.'}, ];

  constructor(public dialogRef: MatDialogRef<ModoDiligenciemientoComponent>,
  	@Inject(MAT_DIALOG_DATA) public data: any,
    private fb : FormBuilder,) {
      this.form = this.fb.group({
        patrimonioLiquido: new FormControl('', [Validators.required]),
        gradualidad: new FormControl('1', [Validators.required]),
      });
     }
   

  ngOnInit() {
  }

  submit(res: any = '') {
    this.dialogRef.close(res);
  }

  get formControls(){
    return this.form.controls;
  }

  enviar() {
    this.submitted = true;
    if (this.form.valid) {
      let respuesta = {
        patrimonioLiquido: this.form.controls.patrimonioLiquido.value,
        gradualidad: this.form.controls.gradualidad.value,
      }
      this.submit(respuesta);
    }
  }

}



// WEBPACK FOOTER //
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/app/components/shared/modals/calculo-extemporaneidad/calculo-extemporaneidad.component.ts